const comments = [
  {
    name: '追剧达人小王',
    text: '萝卜影视真的太良心了！终于找到一个可以一次性看完电视剧全集的地方，不用每周等更新，周末一口气刷完《狂飙》全39集，体验太好了。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '韩剧迷小丽',
    text: '韩剧更新特别快，眼泪女王刚完结第二天全集就上线了。高清画质流畅不卡，手机上看也很方便，已经推荐给身边所有追剧姐妹了。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '经典重温者',
    text: '在这里找到了很多经典老剧的全集，《琅琊榜》高清修复版画质太好了。不用注册就能看，也没有乱七八糟的广告弹窗，纯净追剧体验满分。',
    rating: 5,
    date: '2026-07-22',
  },
  {
    name: '悬疑剧爱好者',
    text: '《漫长的季节》和《隐秘的角落》全集都在这里看的，国产悬疑剧的巅峰之作。每天都会来看看有没有新的电视剧大结局更新，已经成了日常习惯。',
    rating: 4,
    date: '2026-07-20',
  },
  {
    name: '日剧追番人',
    text: '日剧资源也挺全的，《重启人生》和《silent》全集都有收录。高清在线播放稳定，希望能多收录一些经典日剧的全集完整版，会一直支持萝卜影视。',
    rating: 5,
    date: '2026-07-18',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              观众热评
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              来自追剧爱好者的真实评价，看看大家怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className={`bg-background-100 rounded-xl p-5 md:p-6 border border-background-300/30 ${
                  i === 0 ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-xs ${
                        j < comment.rating
                          ? 'ri-star-fill text-accent-400'
                          : 'ri-star-line text-foreground-600'
                      }`}
                    ></i>
                  ))}
                </div>
                <p className="text-foreground-300 text-sm leading-relaxed mb-4">
                  "{comment.text}"
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-100 text-sm font-medium">
                    {comment.name}
                  </span>
                  <span className="text-foreground-500 text-xs">{comment.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}